export default __webpack_public_path__ + "static/Black-Box-0fc34740eff8fca4aca4843c06c939b9.mp3";